<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-coupon-level-dialog-form">
    <b>Coupon Code:</b> {{ data.couponCode }}<br />
    <mat-label>Applies To</mat-label>
    <mat-radio-group name="LevelType" [(ngModel)]="LevelType">
      <mat-radio-button value="Interactive">Interactive&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button>
      <mat-radio-button value="Report">Reporting Services&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button>
    </mat-radio-group>
    <br />
    <ng-container *ngIf="LevelType === 'Interactive'">
      <mat-form-field>
        <mat-label>Subscription Type</mat-label>
        <mat-select (selectionChange)="updateInteractiveType()"
                    name="data.interactSubscriptionTypeId"
                    style="width: 100%"
                    [(ngModel)]="data.interactSubscriptionTypeId">
          <mat-option *ngFor="let subType of data.interactSubscriptionTypes"
                      [value]="subType.interactSubTypeId">{{ subType.interactSubTypeName }}</mat-option>
        </mat-select>
      </mat-form-field><br />
      <mat-form-field>
        <mat-label>Subscription Level</mat-label>
        <mat-select name="data.interactSubscriptionLevelId"
                    style="width: 100%"
                    [(ngModel)]="data.interactSubscriptionLevelId">
          <mat-option *ngFor="let subLevel of filteredSubLevels"
                      [value]="subLevel.interactSubLevelId">{{ subLevel.description }}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="LevelType === 'Report'">
      <mat-form-field>
        <mat-label>Subscription Type</mat-label>
        <mat-select (selectionChange)="updateReportType()"
                    name="data.reportSubscriptionTypeId"
                    style="width: 100%"
                    [(ngModel)]="data.reportSubscriptionTypeId">
          <mat-option *ngFor="let subType of data.reportSubscriptionTypes"
                      [value]="subType.reportSubscriptionTypeId">{{ subType.name }}</mat-option>
        </mat-select>
      </mat-form-field><br />
      <mat-form-field>
        <mat-label>Subscription Level</mat-label>
        <mat-select name="data.reportSubscriptionLevelId"
                    style="width: 100%"
                    [(ngModel)]="data.reportSubscriptionLevelId">
          <mat-option *ngFor="let subLevel of filteredReportSubscriptionLevels"
                      [value]="subLevel.reportSubscriptionLevelId">{{ subLevel.description }}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>  
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Coupon Level
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
